"use client"

import { createContext, useContext } from "react"

export type AccordionGroupContextValue = {
  registerItem: (id: string) => () => void
  isItemOpen: (id: string) => boolean
  toggleItem: (id: string) => void
}

export const AccordionGroupContext =
  createContext<AccordionGroupContextValue | null>(null)

export function useAccordionGroup() {
  return useContext(AccordionGroupContext)
}
